import { DeliveryOptionsEnum } from '../DeliveryPromise';
import { CustomerDetails } from './Customer';
import { PickupInformation, PickupPoint } from './PickupPoint';

export type DeliveryInfo = {
  chosenClickAndCollectStoreId?: number; // @TODO: Remove this after removing the old checkout
  chosenDeliveryOption: DeliveryOptionsEnum | null;
  country: string;
  customerDetails?: CustomerDetails;
  deliveryAddress: DeliveryAddress;
  deliveryAddresses: Array<DeliveryAddress> | null;
  deliveryDate: string | null;
  deliveryOptions: Array<DeliveryOption>;
  deliveryTimeslot: {
    end: string | null;
    start: string | null;
  };
  idCountry?: number;
  orderReference: string;
  pickupInformation?: PickupInformation;
  priceDelivery?: number;
  requiresDelivery?: boolean;
  store: number | null;
  storeNumber: number | null;
  zipCode: string | null;
  locationDTO: PickupPoint | null;
};

export type DeliveryOption = {
  cutoff?: string;
  deliveryFrom: number;
  deliveryMessage: string;
  deliveryOptionId: number;
  deliveryTo: number;
  deliveryUnit: string;
  displayName: string;
  exclusionCausedByProduct: boolean;
  geolocationEnabled: boolean;
  hasDeliveryMessage: boolean;
  name: DeliveryOptionsEnum;
  priceCurrency: string;
  priceDelivery: number;
  provider: string;
  requiresPhoneNumber: boolean;
  sendDate: string;
  showPhoneNumber: boolean;
  namedDayEnabled?: boolean;
  productCodesCausingExclusion?: Array<string>;
  productIdsCausingExclusion?: Array<string>;
  settings?: null | Record<string, unknown>;
};

export type DeliveryDate = {
  date: number;
  label: string;
};

export type DeliveryAddress = {
  addToProfile?: boolean;
  country?: string;
  countryCode?: string;
  firstName?: string;
  idCountry?: number;
  idTitle?: number;
  lastName?: string;
  middleName?: string;
  customTown?: boolean;
  companyName?: string;
  address?: string;
  houseNumber?: string;
  houseNumberAddition?: string;
  postCode?: string;
  city?: string;
  addressLine2?: string;
  addressLine3?: string;
  addressLine4?: string;
  county?: string;
  defaultAddress: boolean;
  deliveryName?: string;
  deliveryAddressId?: number;
  isActive: boolean | null;
  mainAddress?: boolean;
  state?: string;
  stateIso?: string;
  phoneNumber?: string;
};

export type CustomerAddresses = {
  customerAddress: DeliveryAddress;
  deliveryAddresses: Array<DeliveryAddress>;
};

export type DeliveryErrors = Record<DeliveryOptionsEnum, string>;
